import { createFileRoute } from '@tanstack/react-router';
import { PeopleCreateRouteView } from '@/pages/workspaces/people/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware
 * branch of the resolver rebuilds the target from the bundle prefix — which
 * would find no `/journeys/` here and land on the Journeys home instead.
 */
function ProfilesCreateRoute() {
  return (
    <LastWorkspaceResolver>
      <PeopleCreateRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/profiles/create')({
  component: ProfilesCreateRoute,
});
